<template>
  <div id="dashboard">
    <div
      v-if="showLogo"
      :style="{
        padding: '5px 15px',
        textAlign: 'right',
        height: '60px',
        borderBottom: '3px solid ' + distributorBrand.color,
      }"
    >
      <img
        style="width: 350px; max-height: 50px"
        :src="distributorBrand.logo"
        alt="logo"
      />
    </div>
    <div class="content project middle" v-loading="loading">
      <div class="cell">
        <div class="container">
          <p class="sub-title text-center"><b>BLACK NOVA</b> PARTNER PORTAL</p>
          <div class="row mt50">
            <div class="col-xs-8">
              <div class="row">
                <div class="col-xs-6 mb30">
                  <router-link class="w100 dash-button border" to="/collection">
                    <i
                      class="iconfont3 icon-IconBig-ArtworkTool font36 pull-right lh1"
                    ></i>
                    <div class="h42">
                      <b>Artwork Tool</b>
                      <br />
                      <span class="gray"></span>
                    </div>
                  </router-link>
                </div>
                <div class="col-xs-6 mb30" v-if="$store.getters.canSeePage('TR')">
                  <router-link
                    class="w100 dash-button pt border"
                    to="/technical-support"
                  >
                    <i
                      class="iconfont3 icon-IconSupport font36 pull-right lh1"
                    ></i>
                    <div class="h42">
                      <b>TECHNICAL RESOURCES</b>
                    </div>
                  </router-link>
                </div>
                <div class="col-xs-6 mb30">
                  <router-link class="w100 dash-button border" to="/myartworks">
                    <i
                      class="iconfont3 icon-IconDashboard-Manageusers2 font36 pull-right lh1"
                    ></i>
                    <div class="h42">
                      <b>My artworks</b>
                      <br />
                      <span class="gray">{{ artworksCount }} Artworks</span>
                    </div>
                  </router-link>
                </div>
                <div class="col-xs-6 mb30" v-if="$store.getters.canSeePage('SR')">
                  <router-link
                    class="w100 dash-button border"
                    to="/sales-resources"
                  >
                    <i
                    :style="{ lineHeight: userType == 'admin' ? 0.5 : 1 , fontSize: userType == 'admin' ? '25px' : '36px'}" class="iconfont3 icon-IconDashboard-Manageusers3 pull-right"
                    ></i>
                    <div class="h42" :style="{ lineHeight: userType == 'admin' ? 0.5 : 1 }">
                      <b>SALES RESOURCES</b>
                    </div>
                  </router-link>
                  <router-link
                    v-if="userType == 'admin'"
                    class="dash-button db-top border"
                    style="
                      padding: 4px 20px;
                      height: 35px;
                      position: absolute;
                      left: 15px;
                      bottom: 0px;
                    "
                    to="/sales-resources/manage"
                  >
                    <i
                      class="iconfont3 icon-IconSettings font25 pull-right lh1"
                    ></i>
                    <div style="line-height: 25px">
                      <b>Backend</b>
                    </div>
                  </router-link>
                </div>
                <div class="col-xs-6 mb30">
                  <router-link class="w100 dash-button border" to="/myprojects">
                    <i
                      class="iconfont3 icon-IconDashboard-Manageusers font36 pull-right lh1"
                    ></i>
                    <div class="h42">
                      <b>My projects</b>
                      <br />
                      <span class="gray">{{ projectsCount }} Projects</span>
                    </div>
                  </router-link>
                </div>
                <div class="col-xs-6 mb30" v-if="$store.getters.canSeePage('SP')">
                  <router-link
                    class="w100 dash-button border"
                    to="/salespipeline"
                  >
                    <i
                      class="iconfont3 icon-pipeline font36 pull-right lh1"
                    ></i>
                    <div class="h42">
                      <b>Sales Pipeline</b>
                    </div>
                  </router-link>
                </div>
                <div
                  class="col-xs-6 mb30"
                  v-if="
                    userType == 'admin' ||
                    userType == 'salesvp' ||
                    userType == 'salesmanager' ||
                    userType == 'distributors' ||
                    userType == 'distributorsmanager'
                  "
                >
                  <router-link class="w100 dash-button border" to="/myusers">
                    <i
                      class="iconfont3 icon-IconDashboard-Manageusers1 font36 pull-right lh1"
                    ></i>
                    <div class="h42">
                      <b>Manage Users</b>
                      <br />
                      <span class="gray">{{ usersCount }} Users</span>
                    </div>
                  </router-link>
                </div>
                <div class="col-xs-6 mb30" v-if="userType == 'admin'">
                  <a
                    class="w100 dash-button border"
                    target="_blank"
                    href="https://blacknova.co/category/news/"
                  >
                    <i
                      class="iconfont3 icon-IconGlobe font36 pull-right lh1"
                    ></i>
                    <div class="h42">
                      <b>Black Nova public news</b>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="col-xs-4">
              <a href="#/news/" class="border inlineb mb30 w100">
                <div
                  class="bg-gray bg2"
                  :style="{
                    height: '170px',
                    backgroundImage:
                      'url(' +
                      $store.state.serverURL +
                      '/' +
                      latestPost.file_name +
                      ')',
                  }"
                ></div>
                <div class="p10" style="height: 98px">
                  <p class="gray text-upp">PARTNER NETWORK NEWS</p>
                  <p class="font16 black" style="margin-bottom: 0px">
                    {{ latestPost.title }}
                  </p>
                </div>
              </a>
              
              <div class="row">
                <div class="col-xs-12 mb30" v-if="userType != 'admin' && userType != 'salesvp'">
                  <a
                    class="w100 dash-button border"
                    target="_blank"
                    href="https://blacknova.co/category/news/"
                  >
                    <i
                      class="iconfont3 icon-IconGlobe font36 pull-right lh1"
                    ></i>
                    <div class="h42">
                      <b>Black Nova public news</b>
                    </div>
                  </a>
                </div>
                <div class="col-xs-12 mb30">
                  <router-link
                    v-if="
                      ['admin', 'salesvp', 'salesmanager'].includes(userType)
                    "
                    class="w100 dash-button border"
                    style="padding: 20px 20px; height: 57px"
                    to="/finder"
                  >
                    <div>
                      <b>Finder</b>
                    </div>
                  </router-link>
                  <router-link
                    v-if="userType == 'admin'"
                    class="w100 dash-button border"
                    style="padding: 8px 20px; border-top: 0px; height: 57px"
                    to="/managernews"
                  >
                    <i
                      class="iconfont3 icon-IconSettings font36 pull-right lh1"
                    ></i>
                    <div>
                      <b>Backend - partner news</b>
                      <br />
                      <span class="gray">{{ postsCount }} Posts</span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "../assets/css/project.css";
import axios from "axios";
export default {
  name: "dashboard",
  data() {
    return {
      loading: true,
      projectsCount: 0,
      artworksCount: 0,
      usersCount: 0,
      postsCount: 0,
      latestPost: {
        file_name: "",
        title: "",
      },
      userType: this.$store.state.user ? this.$store.state.user.type : null,
      newsImg: require("../assets/images/footer-bg.jpg"),
      distributorBrand: {},
    };
  },
  async mounted() {
    var r1 = this.get_posts();
    var r2 = this.get_artworks_count();
    var r3 = this.get_projects_count();
    if (
      this.userType == "admin" ||
      this.userType == "salesvp" ||
      this.userType == "salesmanager" ||
      this.userType == "distributors" ||
      this.userType == "distributorsmanager"
    ) {
      var r4 = this.get_users_count();
      var users_count = await r4;
      this.usersCount = users_count.data.count;
    }
    var posts = await r1;
    var artworks_count = await r2;
    var projects_count = await r3;
    this.projectsCount = projects_count.data.count;
    this.artworksCount = artworks_count.data.count;
    this.postsCount = posts.data.length;
    this.latestPost = posts?.data[0] || [];
    if (
      this.userType == "distributors" &&
      this.$store.state.user.file_name != ""
    ) {
      if (
        typeof this.$store.state.user.file_name != "undefined" &&
        this.$store.state.user.file_name != ""
      ) {
        this.distributorBrand = {
          color: this.$store.state.user.color,
          logo:
            this.$store.state.serverURL +
            "/" +
            this.$store.state.user.file_name +
            "?" +
            Date.now(),
        };
      }
      if (
        this.userType == "dealers" ||
        this.userType == "distributorsmanager"
      ) {
        axios
          .get("/user/single/" + this.$store.state.user.created_by)
          .then((response) => {
            if (
              response.data &&
              typeof response.data.file_name != "undefined" &&
              response.data.file_name != ""
            ) {
              this.distributorBrand = {
                color: response.data.color,
                logo:
                  this.$store.state.serverURL +
                  "/" +
                  response.data.file_name +
                  "?" +
                  Date.now(),
              };
            }
          });
      }
    }
    this.loading = false;
  },
  methods: {
    async get_posts() {
      return await axios.get("/news/");
    },
    async get_projects_count() {
      return await axios.get("/project/count");
    },
    async get_artworks_count() {
      return await axios.get("/artwork/count");
    },
    async get_users_count() {
      return await axios.get("/user/count");
    },
  },
  computed: {
    showLogo() {
      return (
        (this.userType == "distributors" ||
          this.userType == "distributorsmanager" ||
          this.userType == "dealers") &&
        typeof this.distributorBrand.logo != "undefined"
      );
    },
  },
  created: function () {
    this.$parent.headerB();
    this.$parent.headerNoBg();
  },
};
</script>

<style>
</style>
